import { S3_BUCKET_URL } from '@/constants';
import { AGE_ROLEPLAY_OPTIONS } from '@/pages/Onboarding/options/AgeRoleplay/AGE_ROLEPLAY_OPTIONS';
import { BODY_SHAPE_OPTIONS } from '@/pages/Onboarding/options/BodyShape/BODY_SHAPE_OPTIONS';
import { OUTFIT_STYLE_OPTIONS } from '@/pages/Onboarding/options/OutfitStyle/OUTFIT_STYLE_OPTIONS';
import { ROOM_SELECTION_OPTIONS } from '@/pages/Onboarding/options/RoomSelection';

import { ScreenAboutLook } from './screens/AboutLook';
import { ScreenAge } from './screens/Age';
import { ScreenBehaviorSelection } from './screens/BehaviorSelection';
import { ScreenBodyShape } from './screens/BodyShape';
import { ScreenEmail } from './screens/Email';
import { ScreenExperienceGallery } from './screens/ExperienceGallery';
import { NameScreen } from './screens/Name';
import { ScreenOutfitStyle } from './screens/OutfitStyle';
import { ScreenRoomPreview } from './screens/RoomPreview';
import { ScreenRoomSelection } from './screens/RoomSelection';
import { ScreenSettingUpProfile } from './screens/SettingUpProfile';
import { WelcomeScreen } from './screens/Welcome';
import { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: WelcomeScreen,
    images: [],
  },
  room_selection: {
    component: ScreenRoomSelection,
    images: ROOM_SELECTION_OPTIONS.map(
      (option) =>
        `${S3_BUCKET_URL}/own-ai-roleplay-rooms/backgrounds/${option.id.replace(/_/g, '-').replace('hotel-suit', 'hotel-suite').replace('strip-club-room', 'strip-club').replace('shower', 'Shower')}.png`,
    ),
  },
  room_preview: {
    component: ScreenRoomPreview,
    images: [],
  },
  age: {
    component: ScreenAge,
    images: AGE_ROLEPLAY_OPTIONS.map(
      (option) =>
        `${S3_BUCKET_URL}/own-ai-roleplay-rooms/age-v2/sprite-${option.id}.png`,
    ),
  },
  body_shape: {
    component: ScreenBodyShape,
    images: BODY_SHAPE_OPTIONS.map(
      (option) => `${S3_BUCKET_URL}/layout-own-ai/body_shape/${option.id}.png`,
    ),
  },
  outfit_style: {
    component: ScreenOutfitStyle,
    images: OUTFIT_STYLE_OPTIONS.map(
      (option) =>
        `${S3_BUCKET_URL}/own-ai-roleplay-rooms/outfit-style/${option.id}.png`,
    ),
  },
  about_look: {
    component: ScreenAboutLook,
    images: [`${S3_BUCKET_URL}/layout-own-ai/bg-about-look.png`],
  },
  name: {
    component: NameScreen,
    images: [],
  },
  behavior_selection: {
    component: ScreenBehaviorSelection,
    images: [],
  },
  experience_gallery: {
    component: ScreenExperienceGallery,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  name: '',
  email: '',
  room_selection: null,
  age: null,
  body_shape: null,
  outfit_style: null,
  behavior_selection: null,
  characters: [],
};

// GIRLS CATEGORIES
export const HARDCODED_CATEGORIES = [];
